import type RouterService from '@ember/routing/router-service'
import { service } from '@ember/service'
import Component from '@glimmer/component'
import { t, type IntlService } from 'ember-intl'
import { ReportingControls } from 'teacher-ui-client/components/reporting/controls'
import { ReportingControlsGap } from 'teacher-ui-client/components/reporting/controls-gap'
import { ReportingExportSelect } from 'teacher-ui-client/components/reporting/export-select'
import { ReportingPeriodSelect } from 'teacher-ui-client/components/reporting/period-select'
import { ReportingTableOrChartSelector } from 'teacher-ui-client/components/reporting/table-or-chart-selector'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import type RexDashboardStudentRoute from 'teacher-ui-client/reporting/ui-scope/rex/dashboard/student/route'
import { pageTitleFromRouteInfo, exportOptionsFromRouteInfo } from 'teacher-ui-client/utils/routing'
import StudentSearch from 'teacher-ui-client/components/student-search'
import RouteTemplate from 'ember-route-template'

interface Signature {
  Args: {
    model: ModelFor<RexDashboardStudentRoute>
  }
}

export class RexDashboardStudentPage extends Component<Signature> {
  @service router!: RouterService

  @service intl!: IntlService

  get pageTitle() {
    const title =
      pageTitleFromRouteInfo(this.router.currentRoute) ??
      this.intl.t('pages.reporting.readingEggspress.dashboard.student.title')
    return `${this.args.model.student.fullName} - ${title}`
  }

  get isDetailedPage() {
    return !this.router.currentRoute?.name.endsWith('dashboard.student.index')
  }

  get exportOptions() {
    return exportOptionsFromRouteInfo(this.router.currentRoute)
  }

  <template>
    <ReportingTeacherUiHeader
      @title={{this.pageTitle}}
      @returnLinkText={{if
        this.isDetailedPage
        (t "pages.reporting.readingEggspress.dashboard.student.returnLink")
        (t "pages.reporting.readingEggspress.dashboard.student.returnLinkAll")
      }}
      @returnLinkRoute={{if
        this.isDetailedPage
        "reporting.ui-scope.rex.dashboard.student"
        "reporting.ui-scope.rex.dashboard.table"
      }}
    />
    <ReportingControls>
      <ReportingPeriodSelect data-test-dashboard-date-range-picker />
      <ReportingControlsGap />
      <ReportingTableOrChartSelector
        @studentId={{@model.student.id}}
        @chartRoute="reporting.ui-scope.rex.student-summary"
        @tableRoute="reporting.ui-scope.rex.dashboard.student"
      />
      <ReportingControlsGap />
      <ReportingExportSelect @exportOptions={{this.exportOptions}} />
      <ReportingControlsGap />
      <StudentSearch
        @studentRouteName="reporting.ui-scope.rex.dashboard.student"
        @classRouteName="reporting.ui-scope.rex.dashboard.table"
        @students={{@model.scopedStudents}}
        @excludedStudent={{@model.student}}
        @includeSelectAll={{true}}
      />
    </ReportingControls>
    {{outlet}}
  </template>
}

export default RouteTemplate(RexDashboardStudentPage)
